<template>
  <div class="editor">
    <!-- 热词 -->
    <div v-show="!showHintList && !device.isHarmony && !isOverseas" class="keyword-bar">
      <span class="title">{{ $t("wantToAsk") }}</span>
      <div class="keyword-sroll">
        <div class="capsule" @click="handleVipRelative">{{ $t("vip") }}</div>
        <div
          v-for="hotWord in hotWordList"
          :key="hotWord.word"
          class="capsule"
          @click="onClickHotWord(hotWord)"
        >
          {{ hotWord.word }}
        </div>
      </div>
    </div>
    <!-- 输入栏 -->
    <div
      ref="inputBar"
      class="input-bar"
      :class="{ inputing: inputText }"
      :style="textBarStyle"
    >
      <!-- 文本输入框 -->
      <textarea
        ref="inputBox"
        v-model="inputText"
        rows="1"
        :style="textareaStyle"
        :placeholder="$t('inputbox_text')"
        @keydown="autoResize"
        @focus="onFocus"
        @blur="onBlur"
      />
      <div v-show="inputText" class="send-btn" @click="onSend">
        {{ $t("send") }}
      </div>
      <img
        v-show="!inputText"
        class="add-icon"
        :style="addIconStyle"
        src="@/assets/img/feedback/close.png"
        @click="onShowOrHidePickerView"
      />
      <!-- 关联问题提示 -->
      <div
        v-show="showHintList"
        ref="hintView"
        class="hint-list"
        :style="hintViewStyle"
      >
        <div
          v-for="hint in hintList"
          :key="getHintKey(hint)"
          class="hint-item"
          @click="onClickHint(hint)"
        >
          <p>
            <!-- span必须这么写，要不然文本之间会有多余的空格 -->
            <span
              v-for="(hItem, hIndex) in hint"
              :key="hIndex"
              :class="{ 'hight-light': hItem.highlight }"
              >{{ hItem.word }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <!-- IOS防误触下巴 -->
    <!-- <div v-show="!isFocused && !showPickerView" class="ios-bar"></div> -->
    <!-- 照片、视频选择、拍照 -->
    <div v-show="showPickerView" ref="pickerView" class="picker-view">
      <template v-if="isBelow612">
        <div class="picker-item">
          <div class="img-box" @click="onSelectFile('photo')">
            <img src="@/assets/img/feedback/photo-dark.png" />
            <input
              ref="photoSelect"
              class="file-input"
              type="file"
              multiple
              accept="image/*"
              @change="(e) => onChangeFileInput('photo', e)"
            />
          </div>
          <span>{{ $t("pic") }}</span>
        </div>
        <div class="picker-item">
          <div class="img-box" @click="onSelectFile('video')">
            <img src="@/assets/img/feedback/video-dark.png" />
            <input
              ref="videoSelect"
              class="file-input"
              type="file"
              multiple
              accept="video/mp4,video/quicktime"
              @change="(e) => onChangeFileInput('video', e)"
            />
          </div>
          <span>{{ $t("video") }}</span>
        </div>
      </template>
      <template v-else>
        <div class="picker-item">
          <div class="img-box" @click="onOpenAlblum()">
            <img src="@/assets/img/feedback/photo-dark.png" />
          </div>
          <span>{{ $t("open_album") }}</span>
        </div>
      </template>

      <!-- <div v-if="isAndroid" class="picker-item">
        <div class="img-box" @click="onSelectFile('camera')">
          <img src="@/assets/img/feedback/camera.png" />
          <input
            ref="cameraSelect"
            class="file-input"
            type="file"
            multiple
            capture="camera"
            accept="image/*"
            @change="(e) => onChangeFileInput('camera', e)"
          />
        </div>
        <span>拍摄</span>
      </div> -->
    </div>
  </div>
</template>
<script>
import debounce from "lodash.debounce";
import crypto from "@/utils/crypto";
// import { getImageFileInfo, getVideoFileInfo } from '@/utils/file'
import { getImageFileInfo } from "@/utils/file";
import { rem2px } from "@/utils/formatter";
import device from "@/utils/device";
import { showLoadingToast, closeToast, showToast } from "vant";
import { selectFileAndUpload } from "@/utils/ky-bridge";
import { compareVersion } from "@/utils/tools";
import kylogger from "@ky/sdk/dist/log/kylogger";
import { messageOriginMap } from "@/utils/constant";
import { Urls } from "../constants";

export default {
  name: "Editor",
  props: {
    hotWordList: {
      type: Array,
      default: () => [],
    },
    post: {
      type: Function,
      default: () => {},
    },
    userId: {
      type: String,
      default: "",
    },
    businessId: {
      type: Number,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    isOverseas: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputText: "",
      isFocused: false,
      hintItemH: 0,
      debounceHintList: null,
      hintList: [],
      textareaStyle: {},
      showPickerView: false,
      isBelow612: compareVersion("6.12.0"),
      host: "",
    };
  },
  computed: {
    textBarStyle() {
      if (this.showPickerView || this.isFocused) {
        return {
          "padding-bottom": "0.32rem",
        };
      }
      return {
        "padding-bottom": "1rem",
      };
    },
    showHintList() {
      return this.hintList.length && this.isFocused;
    },
    hintViewStyle() {
      const h = this.hintList.length * this.hintItemH;
      return { top: `-${h}px` };
    },
    addIconStyle() {
      return {
        transform: `rotate(${this.showPickerView ? 45 : 0}deg)`,
        transition: "transform 300ms ease 0",
      };
    },
    isAndroid() {
      return device.isAndroid;
    },
  },
  watch: {
    inputText(val) {
      this.autoResize();
      this.debounceHintList();
      localStorage.setItem("feedback_input_text", val);
    },
    showPickerView() {
      this.$nextTick(() => {
        this.$emit("change-height", this.getNormalEditorHeight());
      });
    },
  },
  created() {
    const config = useRuntimeConfig();
    this.host = config.public.VITE_FEEDBACK_API_HOST;
  },
  mounted() {
    this.hintItemH = rem2px(0.82);

    this.inputText = localStorage.getItem("feedback_input_text") || "";
    this.$emit("change-height", this.getNormalEditorHeight());

    // 鸿蒙屏蔽 关联问题
    if (!device.isHarmony) {
      this.debounceHintList = debounce(this.getInputHintList, 300);
    }
  },
  methods: {
    handleVipRelative() {
      const url = `${Urls.FEEDBACK_FAQ}&initTabKey=vip`;
      window.kwaiying.open(JSON.stringify({ url }));
    },
    onSelectFile(type) {
      this.$refs[`${type}Select`].click();
    },
    async onOpenAlblum() {
      // console.info("zzzzz debug ==onOpenAlblum==");
      kylogger.sendImmediately("CLICK", "UPLOAD_PHOTO_VIDEO");
      await selectFileAndUpload(
        {
          tokenUrl: `${this.host}/rest/n/fb/app/dialog/getTokenForNative`,
        },
        (singleResult) => {
          const type = singleResult?.type;
          const isImg = type?.startsWith("Image");
          const logParams = {
            businessId: this.businessId,
            type: isImg ? "image" : "video",
            fileType: type,
          };
          kylogger.collect("CLICK", "feedback_choose_upload_file", logParams);
          // console.info("zzzzz debug ==selectFileAndUpload== singleResult", singleResult);
          if (singleResult.result === 1) {
            const { width, height, token } = singleResult;
            this.$emit("send-file", {
              type: isImg ? 2 : 3,
              content: token,
              extra: JSON.stringify({
                w: width || 0,
                h: height || 0,
              }),
            });
          }
        },
        (progress) => {
          showLoadingToast({
            message: this.$t("uploading__"),
            duration: 0,
            loadingType: "spinner",
          });
          console.log("progress===", progress);
        },
      );
      closeToast();
    },
    clearInput() {
      this.inputText = "";
    },
    onClickHotWord(hotWord) {
      this.$emit("send-hot-word", hotWord);
    },
    onClickHint(hint) {
      this.$emit("send", {
        word: hint.map((item) => item.word).join(""),
      });
    },
    onSend() {
      kylogger.collect("CLICK", "feedback_send_click", {
        userId: this.userId,
        upload_method: "native",
      });
      this.$emit("send", {
        word: this.inputText,
        messageOrigin: messageOriginMap.User,
      });
    },
    async queryUploadToken(suffix) {
      try {
        const res = await this.$request.get(
          this.host + "/rest/n/fb/app/dialog/getToken",
          {
            params: {
              ...crypto(),
              suffix,
            },
          },
        );
        if (res.result !== 1) {
          throw new Error("获取token失败");
        }
        return res;
      } catch (e) {
        console.log("queryUploadToken e===", e);
      }
    },
    async uploadFile(file, endPoint, token, logParams = {}) {
      const { result } = await this.$request.post(
        `https://${endPoint}/api/upload?upload_token=${token}`,
        file,
        {
          headers: {
            "Content-Type": file.type,
          },
          withCredentials: false,
        },
      );
      if (result !== 1) {
        kylogger.collect("CLICK", "feedback_upload_file_result", {
          ...logParams,
          success: false,
        });
        throw new Error("上传失败");
      }
      kylogger.collect("CLICK", "feedback_upload_file_result", {
        ...logParams,
        success: true,
      });
    },
    async onChangeFileInput(type, e) {
      const files = e.target.files || [];
      showLoadingToast({
        message: this.$t("uploading"),
        duration: 0,
        loadingType: "spinner",
      });
      await Promise.all(
        Array.from(files).map((item) => this.getTokenAndUploadFile(item)),
      );
      this.$refs[`${type}Select`].value = "";
      closeToast();
    },
    byte2ReadableSize(b) {
      if (b < 1024) {
        return b + "B";
      }
      if (b < 1024 * 1024) {
        return Math.round(b / 1024) + "KB";
      }
      const res = Math.round((b * 10) / (1024 * 1024));
      return (res % 10 ? res / 10 : Math.floor(res / 10)) + "MB";
    },
    getTokenAndUploadFile(file) {
      // eslint-disable-next-line
      return new Promise(async (resolve, reject) => {
        try {
          const { name, type, size } = file;
          let fileInfo = { size };
          const isVideo = type.startsWith("video");
          const logParams = {
            businessId: this.businessId,
            type: isVideo ? "video" : "image",
            fileType: type,
            size: this.byte2ReadableSize(size),
          };
          kylogger.collect("CLICK", "feedback_choose_upload_file", logParams);
          if (isVideo) {
            if (size > 150 * 1024 * 1024) {
              closeToast();
              return showToast({
                message: this.$t("uploadLimit"),
                onClose: resolve,
              });
            }
            // 不支持3gp（video/3gpp）格式视频
            // fileInfo = await getVideoFileInfo(file)
          } else {
            if (size > 20 * 1024 * 1024) {
              closeToast();
              return showToast({
                message: this.$t("picLimit"),
                onClose: resolve,
              });
            }
            fileInfo = await getImageFileInfo(file);
          }
          const index = name.lastIndexOf(".");
          const suffix = name.substring(index, name.length).toLowerCase();
          const { endPoint = [], token } = await this.queryUploadToken(suffix);
          kylogger.collect("CLICK", "feedback_upload_file", {
            ...logParams,
            fileName: name,
            endPoint: endPoint[0],
            token,
          });
          await this.uploadFile(file, endPoint[0], token, {
            ...logParams,
            fileName: name,
            endPoint: endPoint[0],
            token,
          });
          this.$emit("send-file", {
            type: type.startsWith("image") ? 2 : 3,
            content: token,
            extra: JSON.stringify({
              w: fileInfo.width || 0,
              h: fileInfo.height || 0,
            }),
          });
          resolve();
        } catch (e) {
          showToast({
            message: this.$t("netError"),
            onClose: resolve,
          });
        }
      });
    },
    blur() {
      this.$refs.inputBox.blur();
    },
    onFocus() {
      this.$emit("input-focus");
      this.isFocused = true;
      this.showPickerView = false;
    },
    onBlur() {
      this.$emit("input-blur");
      // 点击hint-list时延时隐藏
      setTimeout(() => {
        this.isFocused = false;
      }, 0);
    },
    getNormalEditorHeight() {
      return (
        rem2px(0.84) +
        1 +
        this.$refs.inputBar.clientHeight +
        this.$refs.pickerView.clientHeight
      );
    },
    async getInputHintList() {
      try {
        const res = await this.post("/rest/n/fb/app/dialog/getInputHint", {
          content: this.inputText,
        });
        if (res.result === 1) {
          this.hintList = res.highlightList;
        }
      } catch (e) {}
    },
    autoResize() {
      this.textareaStyle = {
        height: "auto",
      };
      this.$nextTick(() => {
        let h = this.$refs.inputBox.scrollHeight;
        const maxH = rem2px(2.3);
        let scrollable = false;
        if (h > maxH) {
          h = maxH;
          scrollable = true;
        }
        this.textareaStyle = {
          height: `${h}px`,
          "overflow-y": scrollable ? "scroll" : "hidden",
        };
        this.$nextTick(() => {
          this.$emit("change-height", this.getNormalEditorHeight());
        });
      });
    },
    getHintKey(hint) {
      return hint.reduce(
        (prevResult, curItem) => prevResult + curItem.word,
        "",
      );
    },
    onShowOrHidePickerView() {
      this.showPickerView = !this.showPickerView;
      if (this.showPickerView) {
        this.$nextTick(() => {
          this.$emit("to-bottom");
        });
      }
    },
    hidePickerView() {
      this.showPickerView = false;
    },
  },
};
</script>
<style lang="less" scoped>
@font-family-default: PingFangSC-Regular;
@font-family-medium: PingFangSC-Medium;

.editor {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // background-color: #fff;
  // height: 2.88rem;
  background-color: #141414;
  border-top: 0.01rem solid rgba(255, 255, 255, 0.06);
  color: rgba(25, 25, 25, 0.7);
  font-size: 0.26rem;
  z-index: 999;

  &::before {
    position: absolute;
    top: 0;
    width: 100%;
    height: 1px;
    content: " ";
    transform: scaleY(0.5);
    background-color: rgba(0, 0, 0, 0.1);
  }

  .keyword-bar {
    display: flex;
    align-items: center;
    // padding: 0.2rem 0 0.1rem 0.34rem;
    padding: 0.2rem 0.32rem;
    height: 1.1rem;

    .title {
      flex-shrink: 0;
      // color: rgba(25, 25, 25, 0.5);
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.26rem;
    }

    .keyword-sroll {
      flex: 1;
      align-self: stretch;
      display: flex;
      align-items: center;
      margin-left: 0.15rem;
      overflow-x: scroll;
      color: rgba(255, 255, 255, 0.9);

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .capsule {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding: 0 0.2rem;
      margin: 0 0.1rem;
      height: 0.56rem;
      box-sizing: border-box;
      // border: solid 1px rgba(0, 0, 0, 0.1);
      border-radius: 0.54rem;
      background: rgba(34, 34, 34, 0.5);
      border: 0.01rem dashed rgba(255, 255, 255, 0.08);
      font-weight: 400;
      font-size: 0.24rem;
      line-height: 0.32rem;
    }
  }

  .input-bar {
    position: relative;
    display: flex;
    align-items: center;
    // padding: 0.1rem 0.25rem 0.2rem 0.34rem;
    // padding: 0 0.32rem 1rem;
    padding: 0 0.32rem;

    &.inputing {
      padding-right: 0.34rem;
    }

    textarea {
      flex: 1;
      display: block;
      padding: 0.14rem 0.2rem;
      height: 0.68rem;
      // border-radius: 0.08rem;
      border-radius: 0.16rem;
      border: none;
      overflow-x: hidden;
      overflow-y: hidden;
      outline: none;
      resize: none;
      word-break: break-all;
      line-height: 0.4rem;
      font-size: 0.28rem;
      font-family: @font-family-default;
      color: rgba(255, 255, 255, 0.9);
      // background-color: rgba(246, 246, 246, 1);
      background-color: rgba(255, 255, 255, 0.08);

      &::placeholder {
        // color: rgba(0, 0, 0, 0.3);
        color: rgba(255, 255, 255, 0.4);
        font-size: 0.26rem;
        line-height: 150%;
        font-family: @font-family-default;
      }
    }

    .hint-list {
      position: absolute;
      left: 0;
      width: 100%;

      .hint-item {
        display: flex;
        align-items: center;
        padding-left: 0.34rem;
        height: 0.82rem;
        box-sizing: border-box;
        background-color: #fff;
        border-bottom: solid 1px rgba(234, 234, 234, 1);
        color: rgba(25, 25, 25, 1);
        font-size: 0.3rem;

        &:last-child {
          border-bottom: none;
        }

        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .hight-light {
          color: #f7365d;
        }
      }
    }

    .send-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.34rem;
      width: 1.12rem;
      height: 0.56rem;
      border-radius: 0.08rem;
      background-color: #f7365d;
      font-size: 0.24rem;
      font-family: @font-family-medium;
      color: rgba(255, 255, 255, 1);
    }

    .add-icon {
      margin-left: 0.25rem;
      width: 0.68rem;
      height: 0.68rem;
      // background-color: rgba(255, 255, 255, 0.08);
      background-color: #141414;
    }
  }

  .ios-bar {
    height: 0.68rem;
    background-color: #141414;
  }

  .picker-view {
    display: flex;
    // height: 2.21rem;
    height: 3.22rem;
    background-color: #141414;
    border-top: 0.01rem solid rgba(255, 255, 255, 0.06);
    padding: 0.32rem;

    .picker-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 0.64rem;

      // margin-top: 0.4rem;
      // margin-left: 0.74rem;
      // &:first-child {
      //   margin-left: 0.64rem;
      // }
      .img-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.12rem;
        height: 1.12rem;
        border-radius: 0.16rem;
        background-color: rgba(255, 255, 255, 0.08);
      }

      img {
        display: block;
        // width: 0.7rem;
        // height: 0.7rem;
        width: 0.56rem;
        height: 0.56rem;
      }

      span {
        margin-top: 0.2rem;
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.24rem;
      }

      .file-input {
        position: absolute;
        top: 0;
        left: -10000px;
      }
    }
  }
}
</style>
